import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, unref as _unref, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0e61b678"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "block required" }
const _hoisted_2 = { class: "block required" }
const _hoisted_3 = { class: "block required" }
const _hoisted_4 = { class: "block required" }
const _hoisted_5 = {
  key: 0,
  class: "block text-xs font-light"
}

import CPhoneInput from "@/components/phoneInput.vue";
import FormErrors from "@/components/FormErrors.vue";
import CButton from "@/components/Button.vue";
import PDropDown from "primevue/dropdown";
import PInput from "primevue/inputtext";
import { ref, onMounted, onBeforeMount } from "vue";
import { cloneDeep } from "lodash";
import { useStore } from "vuex";
import { useVuelidate } from "@vuelidate/core";
import { genderList } from "@/assets/utils/translatedEnums";
import { useI18n } from "vue-i18n";

export default /*#__PURE__*/_defineComponent({
  __name: 'ClientForm',
  props: {
  isLoading: {
    type: Boolean,
    default: false,
  },
  isUpdate: {
    type: Boolean,
    default: false,
  },
  isOnline: {
    type: Boolean,
    default: false,
  },
  client: {
    type: Object,
    default: () => ({}),
  },
  variant: {
    type: String,
    default: () => "app",
  },
},
  emits: ["save", "cancel"],
  setup(__props, { emit }) {

const props = __props;

const { t } = useI18n();
const store = useStore();



const initClient = () => {
  return {
    firstName: "",
    lastName: "",
    phoneNumber: "",
    email: "",
    gender: null,
  };
};
const client = ref();
let v$: any;
const init = () => {
  const rules = props.isUpdate
    ? store.getters["client/rulesToUpdateAClient"]
    : store.getters[
        `client/rulesToCreateA${props.isOnline ? "Online" : ""}Client`
      ];
  client.value = props.isUpdate ? cloneDeep(props.client) : initClient();
  console.log(props.isUpdate, rules);
  v$ = useVuelidate(rules, client, { $lazy: true });
  console.log("init()");
};

onBeforeMount(() => {
  init();
});
const save = async () => {
  if (await v$.value.$validate()) {
    emit("save", cloneDeep(client.value));
  }
};
const cancel = () => {
  init();
  emit("cancel");
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("form", {
    class: "flex flex-col gap-y-4",
    onSubmit: _cache[5] || (_cache[5] = _withModifiers(() => {}, ["prevent"]))
  }, [
    _createElementVNode("div", null, [
      _createElementVNode("label", _hoisted_1, _toDisplayString(_ctx.$t("phoneNumber")), 1),
      _createVNode(CPhoneInput, {
        modelValue: client.value.phoneNumber,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((client.value.phoneNumber) = $event))
      }, null, 8, ["modelValue"]),
      _createVNode(FormErrors, {
        errors: _unref(v$).phoneNumber?.$errors
      }, null, 8, ["errors"])
    ]),
    _createElementVNode("div", null, [
      _createElementVNode("label", _hoisted_2, _toDisplayString(_ctx.$t("gender")), 1),
      _createVNode(_unref(PDropDown), {
        class: "w-full",
        placeholder: _ctx.$t('gender'),
        options: _unref(genderList)(_ctx.$t),
        "option-label": "name",
        "option-value": "id",
        "data-key": "id",
        modelValue: _unref(v$).gender.$model,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(v$).gender.$model) = $event))
      }, null, 8, ["placeholder", "options", "modelValue"]),
      _createVNode(FormErrors, {
        errors: _unref(v$).gender?.$errors
      }, null, 8, ["errors"])
    ]),
    _createElementVNode("div", null, [
      _createElementVNode("label", _hoisted_3, _toDisplayString(_ctx.$t("firstName")), 1),
      _createVNode(_unref(PInput), {
        modelValue: _unref(v$).firstName.$model,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(v$).firstName.$model) = $event)),
        class: "w-full"
      }, null, 8, ["modelValue"]),
      _createVNode(FormErrors, {
        errors: _unref(v$).firstName?.$errors
      }, null, 8, ["errors"])
    ]),
    _createElementVNode("div", null, [
      _createElementVNode("label", _hoisted_4, _toDisplayString(_ctx.$t("lastName")), 1),
      _createVNode(_unref(PInput), {
        modelValue: _unref(v$).lastName.$model,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(v$).lastName.$model) = $event)),
        class: "w-full"
      }, null, 8, ["modelValue"]),
      _createVNode(FormErrors, {
        errors: _unref(v$).lastName?.$errors
      }, null, 8, ["errors"])
    ]),
    _createElementVNode("div", null, [
      _createElementVNode("label", {
        class: _normalizeClass(["block", { required: __props.isOnline }])
      }, _toDisplayString(_ctx.$t("email")), 3),
      _createVNode(_unref(PInput), {
        modelValue: _unref(v$).email.$model,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(v$).email.$model) = $event)),
        class: "w-full"
      }, null, 8, ["modelValue"]),
      (__props.isOnline)
        ? (_openBlock(), _createElementBlock("span", _hoisted_5, "(" + _toDisplayString(_ctx.$t("requiredForOnlineReservation")) + ")", 1))
        : _createCommentVNode("", true),
      _createVNode(FormErrors, {
        errors: _unref(v$).email?.$errors
      }, null, 8, ["errors"])
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(["flex justify-end items-center gap-x-4", { 'pointer-events-none': __props.isLoading }])
    }, [
      _createVNode(CButton, {
        type: "button",
        onClick: save,
        class: "p-button-xs p-button-success"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t("save")), 1)
        ]),
        _: 1
      }),
      _createVNode(CButton, {
        type: "button",
        onClick: cancel,
        class: "p-button-xs p-button-danger"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t("cancel")), 1)
        ]),
        _: 1
      })
    ], 2)
  ], 32))
}
}

})